import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";

const LegalFooter = () => {
  const navigate = useNavigate();
  const [logoBroken, setLogoBroken] = useState(false);

  return (
    <footer className="py-8 px-6 md:px-12 lg:px-24 border-t border-[#1F1F1F] bg-[#111111]">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          {logoBroken ? (
            <div className="w-6 h-6 rounded-lg bg-[#7C3AED] flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-black" />
            </div>
          ) : (
            <img
              src="/logo.png"
              alt="SaaS-Radar"
              className="h-6 w-6 rounded-lg object-contain"
              onError={() => setLogoBroken(true)}
            />
          )}
          <span className="font-semibold text-sm text-white">SaaS-Radar</span>
        </div>

        <div className="flex flex-wrap items-center gap-4 text-xs text-zinc-500">
          <button onClick={() => navigate("/privacy-policy")} className="hover:text-zinc-300 transition-colors">
            Privacy Policy
          </button>
          <button onClick={() => navigate("/terms-of-service")} className="hover:text-zinc-300 transition-colors">
            Terms of Service
          </button>
          <button onClick={() => navigate("/cookie-policy")} className="hover:text-zinc-300 transition-colors">
            Cookie Policy
          </button>
          <button onClick={() => navigate("/legal-notice")} className="hover:text-zinc-300 transition-colors">
            Legal Notice
          </button>
        </div>

        <p className="text-xs text-zinc-500">© 2026 SaaS-Radar. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default LegalFooter;
